import React, { FunctionComponent } from 'react';
import { Card, Modal, Table } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { ModalProps } from '../../types/ModalProps';
import ReactJson from 'react-json-view';

export const MarketingDataModalComponent: FunctionComponent<ModalProps> = ({ showModal = false, onClose, data }) => {
    const { t } = useTranslation();

    return (
        <Modal open={showModal} size={'large'} closeOnEscape={true} closeOnTriggerBlur={true} onClose={onClose}>
            <Modal.Header>{t('lead.detail.box.marketingData.details')}</Modal.Header>
            <Modal.Content scrolling={true}>
                <Card.Content>
                    <Card.Description>
                        <Table celled striped columns={2}>
                            <Table.Body>
                                <ReactJson src={JSON.parse(data.data)} displayDataTypes={false}></ReactJson>
                            </Table.Body>
                        </Table>
                    </Card.Description>
                </Card.Content>
            </Modal.Content>
        </Modal>
    );
};
